// extracted by mini-css-extract-plugin
export default {"container":"Jaa-z","oos":"Kaa-z","oosUx":"Laa-z","selected":"Maa-z","labelOos":"Naa-z"};